import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from "virtual:pwa-register/react";

import { ApiProvider } from "api";
import { ThemeModeProvider } from "components/contexts";
import { LocaleProvider } from "lang";
import { Routes } from "routes";
import { store } from "store";

export const App: React.FC = () => {
  useRegisterSW({
    immediate: true,
    // The browser looks for a new worker only when the page is loaded; an
    // installed PWA is usually resumed, not reloaded. So ask again whenever the
    // app comes back to the foreground (at most once a minute) and every hour
    // while it stays open. When a new worker is found it activates at once
    // (see sw.ts) and the plugin reloads the page.
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      let lastCheck = Date.now();
      const check = () => {
        if (Date.now() - lastCheck < 60_000) return;
        lastCheck = Date.now();
        registration.update().catch(() => undefined);
      };
      setInterval(check, 60 * 60_000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
      });
    },
    onOfflineReady() {
      console.log("App is ready to work offline.");
    },
  });

  return (
    <ApiProvider>
      <LocaleProvider>
        <Provider store={store}>
          <ThemeModeProvider>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </ThemeModeProvider>
        </Provider>
      </LocaleProvider>
    </ApiProvider>
  );
};
